import { render, staticRenderFns } from "./selectCard.vue?vue&type=template&id=2138f0d2&scoped=true&"
import script from "./selectCard.vue?vue&type=script&lang=js&"
export * from "./selectCard.vue?vue&type=script&lang=js&"
import style0 from "./selectCard.vue?vue&type=style&index=0&id=2138f0d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138f0d2",
  null
  
)

export default component.exports